import { t } from 'i18next';
import { useCallback } from 'react';
import { useHandlers } from '../../../context/page-context';
import { downloadBlob } from '../../../utils/download';

const DOWNLOAD_CSV_TEMPLATE_URL =
  'https://cdn.shopify.com/s/files/1/0565/7500/0728/files/Example_CSVs_-_Simple_Example.csv?v=1634317574';

const FILENAME = 'pricing_template.csv';

export function useDownloadCSVTemplate() {
  const { notificationHandler } = useHandlers();

  return useCallback(async () => {
    try {
      const res = await fetch(DOWNLOAD_CSV_TEMPLATE_URL);
      if (!res.ok) {
        throw new Error('Failed to fetch template file');
      }
      const blob = await res.blob();
      downloadBlob(blob, FILENAME);
    } catch (_err) {
      notificationHandler.error(t('price_list_builder.notifications.errors.download'));
    }
  }, [notificationHandler]);
}
